import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import Cookies from 'js-cookie'
// TODO: There is a chance that this paths will be out of sync with current locale. Figure out how to fix it.
import {
  currentStatusDashboardPath,
  timelineDashboardPath,
  factoryDashboardPath,
} from '@/lib/routes'
import { DashboardPageComponent } from '../types'

const dashboardPaths = {
  'dashboard/current_status': currentStatusDashboardPath,
  'dashboard/timeline': timelineDashboardPath,
  'dashboard/factory': factoryDashboardPath,
} as const

export type DashboardStore = {
  dashboardView: DashboardPageComponent
  dashboardPath:
    | typeof currentStatusDashboardPath
    | typeof timelineDashboardPath
    | typeof factoryDashboardPath
  onDashboardViewChange: (dashboardView: DashboardPageComponent) => void
}

export const useDashboardStore = create<DashboardStore>()(
  subscribeWithSelector((set, get) => {
    const dashboardView = (() => {
      const cookie = Cookies.get('dashboard_view') as any
      return cookie in dashboardPaths ? cookie : 'dashboard/current_status'
    })() as DashboardPageComponent

    return {
      dashboardView,
      dashboardPath: dashboardPaths[dashboardView],
      onDashboardViewChange: (dashboardView: DashboardPageComponent) => {
        Cookies.set('dashboard_view', dashboardView, { expires: 365 })
        set({ dashboardView, dashboardPath: dashboardPaths[dashboardView] })
      },
    }
  }),
)

if (import.meta.env.DEV && typeof window !== 'undefined') {
  const __dev = ((window as any).__dev ||= {})
  __dev.useDashboardStore = useDashboardStore
}
